<template lang="pug">
.clearfix(
  v-show='this.conComercios'
  slot='header'
  style='position: relative;'
  )
  .card-container
    p.no-results
      template(v-if="!lCommercial.length && loadingAxios") {{ $t('dashboard.loadingCommerces') }}
      template(v-else-if="!lCommercial.length") {{ $t('dashboard.noResultsCommerces') }}
    tarjeta-cadena-comercios(
      v-for='cadenaComercios in this.lCommercial'
      :data='cadenaComercios'
      :key='cadenaComercios.registro_Numero'
      :class="{ active : cadenaComercios.registro_Numero === activeCard }"
      @active="setActive"
      )

</template>

<script>
import TarjetaCadenaComercios from '@/components/cadena/TarjetaCadenaComercios'
import { mapGetters } from 'vuex'

export default {
  name: 'CommerceModule',

  components: {
    TarjetaCadenaComercios
  },

  data () {
    return {
      conComercios: true,
      activeCard: ''
    }
  },

  computed: {
    ...mapGetters([
      'getlistCommercialData',
      'loadingAxios'
    ]),

    lCommercial: {
      get: function () {
        let datosCommercial = []
        if (this.getlistCommercialData !== undefined) {
          if (this.getlistCommercialData !== '') {
            datosCommercial = this.getlistCommercialData
          }
        }
        return datosCommercial
      },
      set: function () {
        let datosCommercial = []
        if (this.getlistCommercialData !== undefined) {
          if (this.getlistCommercialData !== '') {
            datosCommercial = this.getlistCommercialData
          }
        }
        if (datosCommercial.length >= 1) {
          if (datosCommercial[0].codcadenal === '') {
            this.conComercios = false
          } else {
            this.conComercios = true
          }
        }
      }
    }
  },

  methods: {
    setActive (num) {
      this.activeCard = num
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
}

.direction {
    color: $--color-neutral-1;
}

.info-comercio {
    font-weight: $font-weight-regular;
    margin-top: 11px;
}

.icon-button {
      color: $--color-neutral-2;
}

/deep/ .ods-module__header {
    padding-bottom: 13px;
    padding-top: 20px;
    font-size: 14px;
    font-weight: $font-weight-medium;
}
.no-results {
  font-size: 12px;
  margin-top: 14px;
}
</style>
